<template>
  <div class="standard-checkout-details">
    <div class="card mt-6 mt-lg-0">
      <div class="safe-banner d-none d-lg-flex">
        <i class="icon-shield mr-2"></i>
        <span v-html="'COMPRA 100% SEGURA'"></span>
      </div>

      <div class="card-header d-none d-lg-flex">
        <small class="d-none d-lg-block"
          ><strong class="mr-3">POWERED BY</strong></small
        >
        <img
          class="d-none d-lg-block img-fluid"
          src="../../../assets/images/logo.svg"
        />
      </div>
      <div class="card-body p-0">
        <div class="p-5">
          <span id="summary-purchase" class="font-weight-bold text-secondary"
            >RESUMO DA COMPRA</span
          >
          <hr />
          <div class="d-flex align-items-center purchase-details">
            <img src="../../../assets/images/product-example.svg" />
            <div class="flex-column pl-5 flex-fill">
              <h6 class="mb-0">Nome do Produto</h6>
              <span class="font-weight-light text-secondary text-description"
                >Produto</span
              >
              <div
                id="payment-details"
                class="d-none flex-column justify-conten-between mobile"
                :class="{ longPage }"
              >
                <div class="d-flex justify-content-between mt-6">
                  <h6 class="font-weight-normal">Total a pagar</h6>
                  <h6 class="font-weight-bold">12x R$ 44,00</h6>
                </div>
                <div class="d-flex justify-content-between">
                  <small class="font-weight-normal fs-12">Total à vista</small>
                  <small class="font-weight-normal fs-12">R$ 420,00</small>
                </div>
              </div>
            </div>
          </div>
          <div
            id="payment-details"
            class="d-flex flex-column justify-conten-between desktop"
            :class="{ longPage }"
          >
            <div class="d-flex justify-content-between mt-6">
              <h6 class="font-weight-normal">Total a pagar</h6>
              <h6 class="font-weight-bold">12x R$ 44,00</h6>
            </div>
            <div class="d-flex justify-content-between">
              <small class="font-weight-normal fs-12">Total à vista</small>
              <small class="font-weight-normal fs-12">R$ 420,00</small>
            </div>
          </div>
        </div>
        <div
          class="d-flex flex-column align-items-center bg-light p-0 payment-options"
        >
          <span class="mt-6 font-weight-bold">Formas de pagamento</span>
          <div class="row justify-content-center mt-3 p-5 mb-3">
            <img
              class="m-2"
              src="@/assets/images/checkout-payment/mastercard.png"
            />
            <img class="m-2" src="@/assets/images/checkout-payment/visa.png" />
            <img class="m-2" src="@/assets/images/checkout-payment/amex.png" />
            <img class="m-2" src="@/assets/images/checkout-payment/elo.png" />
            <img
              class="m-2"
              src="@/assets/images/checkout-payment/hipercard.png"
            />
            <img class="m-2" src="@/assets/images/checkout-payment/hiper.png" />
            <img
              class="m-2"
              src="@/assets/images/checkout-payment/diners.png"
            />
            <img
              class="m-2"
              src="@/assets/images/checkout-payment/boleto.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["longPage"],
  computed: {
    ...mapState("product", ["product"])
  }
};
</script>

<style lang="scss" scoped>
.standard-checkout-details {
  color: #212529;

  .card {
    border-radius: 16px;

    .card-title {
      border-radius: 16px 16px 0px 0px;
      min-height: 57px;
      max-height: 57px;
    }
  }

  .ticket {
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 24px;
    }
  }

  .payment-options {
    border-radius: 0px 0px 16px 16px;
  }

  .text-description {
    font-size: 12px;
  }

  .image-badge {
    margin-top: -42px;
    margin-left: -24px;
    position: absolute;
  }
  .safe-banner {
    position: absolute;
    top: 42px;
    left: -8px;
    font-weight: bold;
    display: flex;
    align-items: center;
    padding: 4px 8px;
    font-size: 13px;
    justify-content: center;
    background: #7fcf69;
    color: white;

    i {
      font-size: 24px;
    }
  }

  .card-header {
    font-weight: bold;
    display: flex;
    align-items: center;
    background: white;
    color: #7fcf69;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 16px 16px 0 0;

    @media screen and (min-width: 992px) {
      justify-content: flex-end;
      background: #f8f8f9;
      color: #aeb3be;
      border-bottom: none;
      padding-top: 18px;
      padding-bottom: 22px;
      margin-bottom: 12px;
    }

    @media screen and (max-width: 991px) {
      font-size: 12px;
    }

    i {
      font-size: 24px;
    }

    img {
      max-height: 16px;
    }
  }
  .purchase-details img {
    height: 72px;
    width: 72px;
    object-fit: cover;
    border-radius: 6px;
  }
}
</style>
